import React, { useState, useRef } from 'react';
import { Image, Row, Col, List, Button } from 'antd';
import { useLocation, useNavigate, Link } from 'react-router-dom'
import moment from 'moment';
import { split } from '@apollo/client';
const CustomerPage = (props) => {
    const [visible, setVisible] = useState(false);
    const [url, setUrl] = useState('');
    React.useEffect(() => {
    }, [])
    function showImg(url, copywriting) {
        if (copywriting === '下载图片') {
            setUrl(url)
            setVisible(true)
        }

    }
    return (
        <div style={{ display: props.isCustomer ? "" : "none", width: '100%', marginLeft: '27px', marginRight: '17px', marginTop: '10px' }}>
            <Row>
                <Col style={{ color: '#2657F9', fontSize: '20px' }}>
                    Customer
                </Col>
                <Col style={{ display: props.index === 0 ? "" : "none", color: '#000000', fontSize: '20px', marginLeft: '5px' }}>
                    reported the issue
                </Col>
                <Col style={{ display: props.index === 0 ? "none" : "", color: '#000000', fontSize: '20px', marginLeft: '5px' }}>
                    replied
                </Col>
                <Image
                style={{
                    display: 'none'
                }}
                src={url}
                preview={{
                    visible,
                    scaleStep: '0.5',
                    onVisibleChange: (value) => {
                        setVisible(value);
                    },
                }}
            />
            </Row>
            <div style={{ color: 'rgba(0, 0, 0, 0.55)', fontSize: '14px', height: '30px' }}>{props.day}</div>
            <div style={{ color: 'rgba(0, 0, 0, 0.85)', marginRight: '20px', fontSize: '16px', }}>{props.comment}</div>
            <List
                style={{ marginRight: '30px', padding: '0px',marginTop:'10px' }}
                itemLayout="vertical"
                dataSource={props.filesList}
                renderItem={(item) => (
                    <Row style={{ height: '35px', }}>
                        <Col >
                            {item.img}
                        </Col>
                        <Col onClick={() => showImg(item.url, item.copywriting)} style={{ height: '24px', fontSize: '14px', color: '#3D3D3D' }}>
                            {item.name}
                        </Col>
                        <Col flex="auto" style={{ height: '24px', fontSize: '14px', color: '#3D3D3D', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                            <Button className="btn" style={{ fontSize: '14px', paddingTop: '0px' }} onClick={() => downloadFile(item)} type="text">{item.copywriting}</Button>
                        </Col>
                    </Row>
                )}

            />
        </div>
    )
}
function downloadFile(data) {
    const url = data.url
    fetch(url, {
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        // 获取blob文件流
        return res.blob();
    }).then(blob => {
        let a = document.createElement('a');
        // 通过 blob 对象获取对应的 url
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = data.name;
        a.click();
        a.remove();
    })
}
export default CustomerPage;